var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"footerWrap",staticClass:"cf-footerWrap"},[_c('div',{staticClass:"cf-footerContainer"},[_c('div',{staticClass:"mds-dialog__actions"},[_vm._t("action-button-left"),_c('div',{staticClass:"mds-dialog__actions-right"},[_c('mds-button-container',{attrs:{"right-aligned":""}},[_vm._t("action-button-right")],2)],1)],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }